export default __webpack_public_path__ + "static/media/verdanab.5ef9f456.woff";